import styles from "./PolicyPage.module.css";

export default function PrivacyPolicy() {
  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <p className={styles.eyebrow}>Legal</p>
        <h1 className={styles.title}>Privacy Policy</h1>
        <p className={styles.updated}>Last updated: February 2025</p>
        <div className={styles.divider} />

        <div className={styles.section}>
          <h2>1. Information We Collect</h2>
          <p>When you contact us or make an inquiry through our website, we may collect the following information:</p>
          <ul>
            <li>Your name</li>
            <li>Phone number or WhatsApp contact</li>
            <li>Instagram handle (if contacting via Instagram)</li>
            <li>Delivery address (for order fulfilment)</li>
            <li>Order and payment details</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect solely to:</p>
          <ul>
            <li>Process and fulfil your orders</li>
            <li>Communicate with you regarding your inquiries or purchases</li>
            <li>Arrange delivery of your items</li>
            <li>Provide after-sales support</li>
          </ul>
          <p>We do not use your information for unsolicited marketing or share it with third parties for advertising purposes.</p>
        </div>

        <div className={styles.section}>
          <h2>3. How We Share Your Information</h2>
          <p>We do not sell, trade, or rent your personal information to third parties. Your information may only be shared with:</p>
          <ul>
            <li>Delivery partners strictly for the purpose of fulfilling your order</li>
            <li>Payment processors to complete your transaction securely</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2>4. Data Security</h2>
          <p>We take reasonable precautions to protect your personal information. All communications via WhatsApp are end-to-end encrypted. We do not store card or payment details on our systems.</p>
        </div>

        <div className={styles.section}>
          <h2>5. Cookies</h2>
          <p>Our website may use basic cookies to ensure the site functions correctly. We do not use cookies for tracking or advertising purposes.</p>
        </div>

        <div className={styles.section}>
          <h2>6. Your Rights</h2>
          <p>You have the right to request access to the personal information we hold about you, or to request its deletion. To do so, please contact us directly.</p>
        </div>

        <div className={styles.section}>
          <h2>7. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us:</p>
          <p>WhatsApp: <a href="https://wa.me/94765851400">+94 76 585 1400</a></p>
          <p>Instagram: <a href="https://instagram.com/ratnapuragems" target="_blank" rel="noreferrer">@ratnapuragems</a></p>
        </div>

        <a href="/" className={styles.backBtn}>← Back to Home</a>
      </div>
    </div>
  );
}